import { useEffect, useState } from 'react';
import useMaxOrderableQuantity from '../../availability/queries/useMaxOrderableQuantity';
import useProductQuantities from '../../cart/hooks/useProductQuantities';
import useUpdateCartItemQuantity from '../../cart/hooks/useUpdateCartItemQuantity';
import assert from '../../core/util/assert';

const useProductQuantity = ({
    sku,
    onItemRemove,
    location,
}: {
    sku?: string;
    onItemRemove?: (sku: string) => void;
    location?: string;
}) => {
    const { getQuantityForSku } = useProductQuantities();
    const cartQuantity = getQuantityForSku(sku!);
    const [quantity, setQuantity] = useState(cartQuantity);
    const updateCartItemQuantity = useUpdateCartItemQuantity(onItemRemove);

    const {
        maxOrderQuantity,
        maxOrderQuantityLoading,
        maxAvailableOrderQuantity,
    } = useMaxOrderableQuantity({ sku: sku!, location });
    useEffect(() => {
        setQuantity(cartQuantity);
    }, [cartQuantity, sku]);

    const updateQuantity = async (newQuantity: number) => {
        assert(sku, 'sku is required.');

        setQuantity(newQuantity);
        updateCartItemQuantity(sku, newQuantity);
    };

    return {
        quantity: quantity || 0,
        updateQuantity,
        maxOrderQuantity,
        maxOrderQuantityLoading,
        maxAvailableOrderQuantity,
        loading: quantity !== cartQuantity,
    };
};

export default useProductQuantity;
